// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"122":"24631b5d","492":"4fa2fee5","619":"853b3386","787":"fcbffad6"}[chunkId] + ".chunk.js";
};